import Vue from 'vue'
import {dd,store,app} from 'systems/imports'

import BaseProcessor from 'processor/BaseProcessor'
import API from 'api/DemoRegister'

/**
 * 運営サイト情報
 */
class DemoRegister extends BaseProcessor{
  static getClassName(){ return 'DemoRegister' }

  /**
   */
  static provisionalRegister(input){
    return new Promise(function(resolve, reject) {
        API.provisionalRegister(input)
          .then((res)=>{
          return resolve({status:"ok",data:{user:res.user} })
        }).catch((e)=>{
          switch(e.name){
            case "duplicate_mail_registration":
              return resolve({status:"ng",data:{},apiErrorI18nKey:"error[2][10]"})
          }
        })
    });
  }

  static committalRegister(input){
    return new Promise(function(resolve, reject) {
      API.committalRegister(input)
        .then((res)=>{
          store.set("token",res.token)
          store.set("user",res.user)
          return resolve({status:"ok",data:{token:res.token} })
        }).catch((e)=>{
        switch(e.name){
          case "data_not_exist":
            return resolve({status:"ng",data:{},apiErrorI18nKey:"error[3][4]"})
          case "data_expired":
            return resolve({status:"ng",data:{},apiErrorI18nKey:"error[3][5]"})
        }
      })
    });
  }
}

export default DemoRegister



// WEBPACK FOOTER //
// ./src/processor/DemoRegister.js